import * as React from "react";
import type { SVGProps } from "react";
const SvgBabyPool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 17c4.14 0 7.5-3.36 7.5-7.5S16.14 2 12 2 4.5 5.36 4.5 9.5 7.86 17 12 17M9.57 4.57A2.436 2.436 0 0 0 12 6.88c.55 0 1-.45 1-1s-.45-1-1-1c-.25 0-.44-.2-.44-.44S11.76 4 12 4c3.03 0 5.5 2.47 5.5 5.5S15.03 15 12 15a5.51 5.51 0 0 1-5.5-5.5c0-2.16 1.25-4.03 3.07-4.93m2.41 8.84c.89 0 1.78-.33 2.49-.99.007 0 .013-.009.02-.018l.01-.012c.06-.06.11-.12.15-.19.25-.39.2-.91-.14-1.25-.39-.38-1.02-.38-1.41 0-.61.59-1.61.6-2.18 0a.996.996 0 1 0-1.42 1.4c.68.69 1.58 1.04 2.5 1.04zm-.42-3.91c0 .55-.45 1-1 1s-1-.45-1-1v-.72c0-.55.45-1 1-1s1 .45 1 1zm1.88 1c.55 0 1-.45 1-1v-.72c0-.55-.45-1-1-1s-1 .45-1 1v.72c0 .55.45 1 1 1m7.74 8.92c.33-.45.95-.55 1.4-.23h-.02c.45.33.55.95.23 1.4-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.73-.6-1.17-.58-.5-.01-.94.2-1.21.58a3.34 3.34 0 0 1-2.83 1.42c-1.08-.01-2.14-.51-2.79-1.42-.27-.37-.71-.6-1.17-.58-.51-.01-.94.2-1.21.58-.65.92-1.71 1.45-2.83 1.42-1.06-.01-2.14-.51-2.79-1.42-.32-.45-.22-1.08.23-1.4s1.08-.22 1.4.23c.27.37.7.56 1.17.58.49 0 .94-.2 1.21-.58.65-.91 1.71-1.42 2.83-1.42 1.08 0 2.14.51 2.79 1.42.27.37.71.56 1.17.58.5 0 .94-.2 1.21-.58.65-.91 1.72-1.42 2.83-1.42 1.09 0 2.14.51 2.79 1.42.27.37.7.56 1.17.58.5 0 .94-.2 1.21-.58"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBabyPool;
